var React = require('react');

function Gatsby (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Gatsby icon"),React.createElement("path",{"d":"M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 2.571c3.171 0 5.915 1.543 7.629 3.858l-1.286 1.115C16.886 5.572 14.571 4.286 12 4.286c-3.343 0-6.171 2.143-7.286 5.143l9.857 9.857c2.486-.857 4.373-3 4.973-5.572h-4.115V12h6c0 4.457-3.172 8.228-7.372 9.17L2.83 9.944C3.772 5.743 7.543 2.57 12 2.57zm-9.429 9.6l9.344 9.258c-2.4-.086-4.801-.943-6.601-2.743-1.8-1.8-2.743-4.201-2.743-6.515z","key":1})]);
}

Gatsby.defaultProps = {"role":"img","viewBox":"0 0 24 24"};

module.exports = Gatsby;

Gatsby.default = Gatsby;
